import http from "../../http";

const BASE = "/gateway/syinfopublish/api/pc/information/appointment";

const informationAppointment = {
  create(param) {
    return http.spin.payload(`${BASE}/create`, param);
  },
  update(param) {
    return http.spin.payload(`${BASE}/update`, param);
  },
  selectAppointmentPeriodList(param) {
    return http.spin.get(`${BASE}/selectAppointmentPeriodList`, param);
  },
  selectAppointmentPeriodPage(param) {
    return http.spin.get(`${BASE}/selectAppointmentPeriodPage`, param);
  },
  changePeriod(param) {
    return http.spin.post(`${BASE}/changePeriod`, param);
  },
  changePeriodSetting(param) {
    return http.spin.post(`${BASE}/changePeriodSetting`, param);
  },
  generateCyclePeriodRecords(param) {
    return http.spin.post(`${BASE}/generateCyclePeriodRecords`, param);
  },
  queryAppointmentUserPageV2(param) {
    return http.spin.get(`${BASE}/queryAppointmentUserPageV2`, param);
  },
  exportAppointmentUserPageV2(param) {
    return http.get(`${BASE}/exportAppointmentUserPageV2`, param);
  },
  changeAppointmentUserRecord(param) {
    return http.spin.post(`${BASE}/changeAppointmentUserRecord`, param);
  },
  selectDynamicFormHeader(param) {
    return http.get(`${BASE}/selectDynamicFormHeader`, param);
  },
  queryDynamicFormDataPage(param) {
    return http.spin.payload(`${BASE}/queryDynamicFormDataPage`, param);
  },
  selectAcquisitionAnalysis(param) {
    return http.get(`${BASE}/selectAcquisitionAnalysis`, param);
  },
  deleteRecordById(param) {
    return http.spin.post(`${BASE}/deleteRecordById`, param);
  },
  distributePoints(param) {
    return http.spin.post(`${BASE}/distributePoints`, param);
  },
  downloadDynamicForm(param) {
    return http.spin.payload(`${BASE}/downloadDynamicForm`, param);
  },
  /** 分页查询活动预约排号记录 */
  selectAppointmentUserCardPage(param) {
    return http.spin.get(`${BASE}/selectAppointmentUserCardPage`, param);
  },
  /** 自定义小程序社区通知推送 */
  pushMessageCustomize(param) {
    return http.spin.payload(`${BASE}/pushMessageCustomize`, param);
  },
};

export default informationAppointment;
